import { useRef, useEffect, useState } from 'react';
import { useSlate } from 'slate-react';
import { onChangeDOM } from '@sdk/types/DOM';

import { insertLink, updateLinkUrl } from '@web/richText/helpers/utils';

import { Props } from './EditLinkForm';

export const useEditLinkForm = ({ initialUrl = '', isVisible, close, onSubmit }: Props) => {
  const [url, setUrl] = useState(initialUrl);
  const editor = useSlate();
  const urlInputRef = useRef<HTMLInputElement>(null);
  const [isInvalid, setIsInvalid] = useState(false);

  useEffect(() => {
    if (isVisible) {
      setTimeout(() => {
        urlInputRef.current?.focus();
      });
    }
  }, [isVisible]);

  useEffect(() => {
    if (urlInputRef.current) {
      urlInputRef.current.value = initialUrl;
    }

    setUrl(initialUrl);
  }, [initialUrl, setUrl]);

  const addLink = () => {
    const urlToSave = url.trim();
    if (!urlToSave) {
      setIsInvalid(true);
      return;
    }

    close();
    onSubmit?.();
    insertLink(editor, urlToSave);
  };

  const updateUrl = () => {
    close();
    onSubmit?.();
    updateLinkUrl(editor, url);
  };

  const submit = () => {
    initialUrl ? updateUrl() : addLink();
  };

  const changeValue: onChangeDOM = (event) => {
    const { value } = event.target;
    setIsInvalid(!value);
    setUrl(value);
  };

  return {
    changeValue,
    isInvalid,
    submit,
    urlInputRef,
  };
};
